import React from "react";
import DetailsCard from "./DetailsCard";
import { formatUSPhoneNumber } from "../../../../utils/formatters";
import useLang from "../../../../hooks/useLang";

const DeviceDetails = ({ deviceData, onAssignUser, onAssignLocation, canAssignLocation }) => {
  const [gotoLang] = useLang("GoTo");
  // Device details object - using the same fields as the table
  const details = {
    [gotoLang.name]: deviceData?.name || "--",
    [gotoLang.eaiUser]: deviceData?.user?.fullName || null,
    [gotoLang.eaiUserPhone]: deviceData?.user?.phone
      ? formatUSPhoneNumber(deviceData.user.phone)
      : "--",
    [gotoLang.model]: deviceData?.modelName || "--",
    [gotoLang.macAddress]: deviceData?.macAddress || "--",
    ...(canAssignLocation && { Location: deviceData?.originalLocation?.title || null }),
  };

  const handleEdit = fieldKey => {
    if (fieldKey === gotoLang.eaiUser) {
      if (onAssignUser) onAssignUser();
    } else if (fieldKey === "Location") {
      if (onAssignLocation) onAssignLocation();
    }
  };

  return (
    <div className="mb-4">
      {/* Device details using DetailsCard */}
      <DetailsCard
        title={gotoLang.details}
        details={details}
        editableFields={[gotoLang.eaiUser, "Location"]}
        onEdit={handleEdit}
      />
    </div>
  );
};

export default DeviceDetails;
